var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTv({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -70.4590 116.7000 70.4590",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.1172-9.86328L96.582-9.86328C102.979-9.86328 106.934-13.8672 106.934-20.2637L106.934-64.0137C106.934-70.4102 102.979-74.3652 96.582-74.3652L20.1172-74.3652C13.7207-74.3652 9.76562-70.4102 9.76562-64.0137L9.76562-20.2637C9.76562-13.8672 13.7207-9.86328 20.1172-9.86328Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2148-16.9434C18.1152-16.9434 16.7969-18.2129 16.7969-20.3613L16.7969-63.916C16.7969-66.0156 18.1152-67.334 20.2148-67.334L96.4844-67.334C98.584-67.334 99.9023-66.0156 99.9023-63.916L99.9023-20.3613C99.9023-18.2129 98.584-16.9434 96.4844-16.9434Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.8672 3.85742L77.832 3.85742C79.7852 3.85742 81.3477 2.29492 81.3477 0.341797C81.3477-1.61133 79.7852-3.22266 77.832-3.22266L38.8672-3.22266C36.9141-3.22266 35.3516-1.61133 35.3516 0.341797C35.3516 2.29492 36.9141 3.85742 38.8672 3.85742Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTv);
export default __webpack_public_path__ + "static/media/tv.a12373999eaf1500761f44665aad77d6.svg";
export { ForwardRef as ReactComponent };